export const GET_GMB_PROFILE_STARTED = 'GET_GMB_PROFILE_STARTED'
export const GET_GMB_PROFILE_SUCCESS = 'GET_GMB_PROFILE_SUCCESS'
export const GET_GMB_PROFILE_FAILURE = 'GET_GMB_PROFILE_FAILURE'

export const CONNECT_GMB_STARTED = 'CONNECT_GMB_STARTED'
export const CONNECT_GMB_SUCCESS = 'CONNECT_GMB_SUCCESS'
export const CONNECT_GMB_FAILURE = 'CONNECT_GMB_FAILURE'

export const SAVE_GMB_TOKENS_STARTED = 'SAVE_GMB_TOKENS_STARTED'
export const SAVE_GMB_TOKENS_SUCCESS = 'SAVE_GMB_TOKENS_SUCCESS'
export const SAVE_GMB_TOKENS_FAILURE = 'SAVE_GMB_TOKENS_FAILURE'

export const UPDATE_GMB_TOKENS_STARTED = 'UPDATE_GMB_TOKENS_STARTED'
export const UPDATE_GMB_TOKENS_SUCCESS = 'UPDATE_GMB_TOKENS_SUCCESS'
export const UPDATE_GMB_TOKENS_FAILURE = 'UPDATE_GMB_TOKENS_FAILURE'

export const DISCONNECT_GMB_STARTED = 'DISCONNECT_GMB_STARTED'
export const DISCONNECT_GMB_SUCCESS = 'DISCONNECT_GMB_SUCCESS'
export const DISCONNECT_GMB_FAILURE = 'DISCONNECT_GMB_FAILURE'

export const SAVE_GMB_TOKENS_IDLE = 'SAVE_GMB_TOKENS_IDLE'

export const UPDATE_GMB_LOCATION_STARTED = 'UPDATE_GMB_LOCATION_STARTED'
export const UPDATE_GMB_LOCATION_SUCCESS = 'UPDATE_GMB_LOCATION_SUCCESS'
export const UPDATE_GMB_LOCATION_FAILURE = 'UPDATE_GMB_LOCATION_FAILURE'

export const REMOVE_GMB_MESSAGE = 'REMOVE_GMB_MESSAGE'
